var map = {
	"./brand.de-CH.json": 1676,
	"./brand.de-DE.json": 1677,
	"./brand.en-CA.json": 1678,
	"./brand.en-GB.json": 1679,
	"./brand.en-IN.json": 1680,
	"./brand.en-ME.json": 1681,
	"./brand.en-US.json": 1682,
	"./brand.es-EM.json": 1683,
	"./brand.es-ES.json": 1684,
	"./brand.fr-BE.json": 1685,
	"./brand.fr-CA.json": 1686,
	"./brand.fr-CH.json": 1687,
	"./brand.nl-BE.json": 1688,
	"./brand.nl-NL.json": 1689,
	"./brand.pl-PL.json": 1690,
	"./brand.pt-BR.json": 1691
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1675;